// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.access-inbox {
  --access-ink: #142642;
  --access-muted: #52617a;
  --access-border: #dce4ee;
  --access-soft: #f4f7fa;
  --access-accent: #1759ad;
  --access-positive: #12614b;
  --access-warning: #835609;
  --access-danger: #a92f29;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0 0 1rem;
  color: var(--access-ink);
}

.access-inbox .access-inbox__header {
  flex-wrap: wrap;
  margin-bottom: 0;
}

.access-inbox .access-inbox__header .crumb {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}

.access-inbox .access-inbox__header .crumb-icon,
.access-inbox .access-inbox__header .pill-btn {
  flex-shrink: 0;
}

.access-inbox .access-inbox__description {
  margin: 0;
  color: var(--access-muted);
  font-size: 0.875rem;
  line-height: 1.6;
}

.access-inbox .access-button,
.access-inbox .access-icon-button,
.access-inbox .btn-approve,
.access-inbox .btn-deny {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 44px;
  padding: 0.625rem 1rem;
  border: 1px solid var(--access-border);
  border-radius: 0.625rem;
  background: var(--card, #fff);
  color: var(--access-ink);
  font: inherit;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.4;
  cursor: pointer;
  transition: background-color 140ms ease, border-color 140ms ease;
}

.access-inbox .access-button:hover:not(:disabled),
.access-inbox .access-icon-button:hover:not(:disabled) {
  background: #edf2f8;
  border-color: #aebfd4;
}

.access-inbox .access-button--quiet {
  color: var(--access-muted);
  background: transparent;
  border-color: transparent;
}

.access-inbox .access-icon-button {
  flex: 0 0 44px;
  width: 44px;
  padding: 0;
}

.access-inbox .access-icon-button--danger {
  color: var(--access-muted);
  background: transparent;
  border-color: transparent;
}

.access-inbox .access-icon-button--danger:hover:not(:disabled) {
  color: var(--access-danger);
  background: #fff1f0;
  border-color: #edc8c5;
}

.access-inbox button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.access-inbox :is(button, a, input, textarea):focus-visible {
  outline: 3px solid var(--access-accent);
  outline-offset: 3px;
}

.access-inbox .notifications-filters {
  display: flex;
  align-items: center;
  gap: 0.75rem 1.5rem;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  border: 1px solid var(--access-border);
  border-radius: 0.75rem;
  background: var(--card, #fff);
}

.access-inbox .notifications-toggle {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-height: 44px;
  color: var(--access-ink);
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.5;
  cursor: pointer;
}

.access-inbox .notifications-toggle input {
  width: 1rem;
  height: 1rem;
  margin: 0;
  flex: 0 0 1rem;
  accent-color: var(--access-accent);
}

.access-inbox .notifications-count {
  margin-left: auto;
  color: var(--access-muted);
  font-size: 0.75rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.access-inbox .notifications-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.access-inbox .dataspace-content-loading--compact {
  min-height: 18rem;
  border: 1px solid var(--access-border);
  border-radius: 0.875rem;
}

.access-inbox .notification-card {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-width: 0;
  padding: 1.5rem;
  border: 1px solid var(--access-border);
  border-left: 3px solid #94a3b8;
  border-radius: 0.875rem;
  background: var(--card, #fff);
  box-shadow: 0 2px 6px rgba(20, 38, 66, 0.025);
}

.access-inbox .notification-card[data-status="pending"] {
  border-left-color: #c48b29;
}

.access-inbox .notification-card[data-status="approved"] {
  border-left-color: #258069;
}

.access-inbox .notification-card:is([data-status="denied"], [data-status="revoked"]) {
  border-left-color: #c26962;
}

.access-inbox .notification-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
}

.access-inbox .notification-heading {
  min-width: 0;
}

.access-inbox .notification-title {
  margin: 0;
  color: var(--access-ink);
  font-size: 1.0625rem;
  font-weight: 800;
  line-height: 1.5;
  letter-spacing: -0.015em;
  overflow-wrap: anywhere;
}

.access-inbox .notification-subtitle {
  margin: 0.25rem 0 0;
  color: var(--access-muted);
  font-size: 0.75rem;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.access-inbox .notification-actions-inline {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

.access-inbox .access-status {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  flex: 0 0 auto;
  padding: 0.375rem 0.625rem;
  border: 1px solid var(--access-border);
  border-radius: 0.5rem;
  background: var(--access-soft);
  color: var(--access-muted);
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.4;
}

.access-inbox .access-status--pending {
  background: #fff8e8;
  border-color: #eeddb5;
  color: var(--access-warning);
}

.access-inbox .access-status--approved {
  background: #edf8f3;
  border-color: #c8e7d9;
  color: var(--access-positive);
}

.access-inbox :is(.access-status--denied, .access-status--revoked) {
  background: #fff1f0;
  border-color: #efd3d0;
  color: var(--access-danger);
}

.access-inbox .notification-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem 1.5rem;
  margin: 0;
  padding-top: 1rem;
  border-top: 1px solid #edf0f4;
}

.access-inbox .notification-meta > div {
  min-width: 0;
}

.access-inbox .notification-meta__wide {
  grid-column: 1 / -1;
}

.access-inbox .notification-meta dt {
  margin: 0 0 0.375rem;
  color: var(--access-muted);
  font-size: 0.75rem;
  font-weight: 600;
}

.access-inbox .notification-meta dd {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.access-inbox .notification-meta__wide dd {
  font-size: 0.8125rem;
}

.access-inbox .notification-message {
  padding: 0.875rem 1rem;
  border-left: 2px solid #bdcde0;
  border-radius: 0 0.5rem 0.5rem 0;
  background: var(--access-soft);
  font-size: 0.875rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.access-inbox .notification-message strong {
  display: block;
  margin-bottom: 0.375rem;
  color: var(--access-muted);
  font-size: 0.75rem;
}

.access-inbox .notification-message p {
  margin: 0;
  white-space: pre-wrap;
}

.access-inbox .notification-decision {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 2rem;
  padding: 1rem;
  border: 1px solid var(--access-border);
  border-radius: 0.625rem;
  background: var(--access-soft);
  font-size: 0.8125rem;
  line-height: 1.6;
}

.access-inbox .notification-decision > div {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  min-width: 0;
}

.access-inbox .notification-decision strong {
  color: var(--access-muted);
}

.access-inbox .notification-decision__comment {
  flex-basis: 100%;
  overflow-wrap: anywhere;
}

.access-inbox .notification-consent {
  display: grid;
  gap: 1rem;
  padding: 1.25rem;
  border: 1px solid #d8e4f2;
  border-radius: 0.75rem;
  background: #f5f8fc;
  font-size: 0.875rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.access-inbox .notification-consent__item {
  display: grid;
  grid-template-columns: 6rem minmax(0, 1fr);
  gap: 1rem;
}

.access-inbox .notification-consent__item strong {
  font-size: 0.8125rem;
}

.access-inbox .notification-consent__notice {
  padding-top: 1rem;
  border-top: 1px solid #d8e4f2;
  color: #354864;
  font-size: 0.8125rem;
}

.access-inbox .notification-consent__notice p {
  margin: 0.375rem 0 0;
}

.access-inbox :is(.notification-consent__invalid, .notifications-error) {
  padding: 1rem;
  border: 1px solid #e4bbb7;
  border-radius: 0.625rem;
  background: #fff1f0;
  color: #8b2722;
  font-size: 0.875rem;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.access-inbox .notification-actions {
  display: grid;
  gap: 1rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--access-border);
}

.access-inbox .notification-actions h3 {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 800;
}

.access-inbox .notification-inputs {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);
  align-items: start;
  gap: 1rem;
}

.access-inbox .notification-inputs:empty {
  display: none;
}

.access-inbox .notification-inputs label {
  display: grid;
  min-width: 0;
  gap: 0.5rem;
  color: var(--access-muted);
  font-size: 0.75rem;
  font-weight: 700;
}

.access-inbox .notification-inputs :is(input, textarea) {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 44px;
  border: 1px solid #bdcadb;
  border-radius: 0.5rem;
  padding: 0.75rem;
  background: var(--card, #fff);
  color: var(--access-ink);
  font: inherit;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
}

.access-inbox .notification-inputs textarea {
  min-height: 5.5rem;
  resize: vertical;
}

.access-inbox .notification-inputs textarea::placeholder {
  color: #65758a;
  opacity: 1;
}

.access-inbox .notification-buttons {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.access-inbox .btn-approve {
  background: var(--access-ink);
  border-color: var(--access-ink);
  color: #fff;
}

.access-inbox .btn-approve:hover:not(:disabled) {
  background: #25476e;
  border-color: #25476e;
}

.access-inbox .btn-deny {
  color: var(--access-danger);
  border-color: #e3c9c6;
}

.access-inbox .btn-deny:hover:not(:disabled) {
  background: #fff1f0;
  border-color: #cf9f99;
}

.access-inbox .notification-actions--compact {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
}

.access-inbox .notification-actions--compact .notification-inputs {
  display: flex;
  flex: 1 1;
}

.access-inbox .notification-actions--compact .notification-inputs:empty {
  display: none;
}

.access-inbox .notification-actions--compact .notification-buttons {
  margin-left: auto;
}

.access-inbox .notifications-empty {
  display: grid;
  justify-items: center;
  gap: 0.75rem;
  padding: 3rem 1.5rem;
  border: 1px solid var(--access-border);
  border-radius: 0.875rem;
  background: var(--card, #fff);
  text-align: center;
}

.access-inbox .notifications-empty__icon {
  display: grid;
  place-items: center;
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: 0.25rem;
  border-radius: 50%;
  background: #eaf1fa;
  color: var(--access-accent);
  font-size: 1.25rem;
}

.access-inbox .notifications-empty h2 {
  margin: 0;
  font-size: 1.0625rem;
  line-height: 1.5;
}

.access-inbox .notifications-empty p {
  margin: 0;
  color: var(--access-muted);
  font-size: 0.875rem;
  line-height: 1.6;
}

.access-inbox .notifications-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.access-inbox .notifications-page {
  color: var(--access-muted);
  font-size: 0.8125rem;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.access-inbox .access-confirm {
  width: min(32rem, calc(100% - 2rem));
  max-height: calc(100% - 2rem);
  margin: auto;
  padding: 0;
  overflow-y: auto;
  border: 1px solid var(--access-border);
  border-radius: 1rem;
  background: var(--card, #fff);
  color: var(--access-ink);
  box-shadow: 0 24px 80px rgba(20, 38, 66, 0.25);
}

.access-inbox .access-confirm::backdrop {
  background: rgba(15, 30, 51, 0.5);
  backdrop-filter: blur(2px);
}

.access-inbox .access-confirm__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem 1.25rem 0;
}

.access-inbox .access-confirm__icon {
  display: grid;
  place-items: center;
  flex: 0 0 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  background: #fff1f0;
  color: var(--access-danger);
}

.access-inbox .access-confirm__header h2 {
  margin: 0;
  font-size: 1.0625rem;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.access-inbox .access-confirm__header .access-icon-button {
  margin-left: auto;
  border-color: transparent;
}

.access-inbox .access-confirm__body {
  padding: 0.5rem 1.5rem 1rem;
  color: var(--access-muted);
  font-size: 0.875rem;
  line-height: 1.7;
}

.access-inbox .access-confirm__body p {
  margin: 0.75rem 0 0;
}

.access-inbox .access-confirm__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--access-border);
  background: var(--access-soft);
}

.access-inbox .access-button--danger {
  color: #fff;
  background: var(--access-danger);
  border-color: var(--access-danger);
}

.access-inbox .access-button--danger:hover:not(:disabled) {
  color: #fff;
  background: #88221e;
  border-color: #88221e;
}

@media (max-width: 52rem) {
  .access-inbox .notifications-count {
    margin-left: 0;
  }

  .access-inbox .notification-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 38rem) {
  .access-inbox {
    gap: 1rem;
  }

  .access-inbox .notifications-filters {
    align-items: stretch;
    gap: 0.25rem 0.75rem;
    padding: 0.625rem 0.875rem;
  }

  .access-inbox .notifications-toggle {
    width: 100%;
  }

  .access-inbox .notifications-count {
    display: flex;
    align-items: center;
    min-height: 44px;
    flex: 1 1;
  }

  .access-inbox .notification-card {
    padding: 1rem;
    gap: 1rem;
  }

  .access-inbox .notification-head {
    flex-direction: column;
    gap: 0.75rem;
  }

  .access-inbox .notification-actions-inline {
    width: 100%;
    justify-content: space-between;
  }

  .access-inbox .notification-meta {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.875rem;
  }

  .access-inbox .notification-inputs {
    grid-template-columns: minmax(0, 1fr);
  }

  .access-inbox .notification-buttons > button {
    flex: 1 1;
  }

  .access-inbox .notification-actions--compact .notification-buttons {
    width: 100%;
  }

  .access-inbox .notification-actions--compact .notification-inputs label {
    width: 100%;
  }

  .access-inbox .notification-consent {
    padding: 1rem;
  }

  .access-inbox .notification-consent__item {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.25rem;
  }

  .access-inbox .notifications-pagination .access-button {
    padding-inline: 0.625rem;
  }

  .access-inbox .access-confirm__header {
    gap: 0.5rem;
    padding-inline: 1rem;
  }

  .access-inbox .access-confirm__icon {
    display: none;
  }

  .access-inbox .access-confirm__body, .access-inbox .access-confirm__footer {
    padding-inline: 1rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .access-inbox button {
    transition: none;
  }
}

.notification-delivery { padding: 14px; border: 1px solid #edce9b; border-radius: 10px; background: #fff9ee; margin: 14px 0; }
.notification-delivery p { margin: 0 0 8px; }
.notifications-hidden { font-size: 13px; color: #68758b; }
`, "",{"version":3,"sources":["webpack://./src/components/Notifications.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gEAAgE;AAClE;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,sCAAsC;EACtC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,sCAAsC;EACtC,qBAAqB;EACrB,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sCAAsC;EACtC,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAO;EACT;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC7H,2BAA2B,eAAe,EAAE;AAC5C,wBAAwB,eAAe,EAAE,cAAc,EAAE","sourcesContent":[".access-inbox {\n  --access-ink: #142642;\n  --access-muted: #52617a;\n  --access-border: #dce4ee;\n  --access-soft: #f4f7fa;\n  --access-accent: #1759ad;\n  --access-positive: #12614b;\n  --access-warning: #835609;\n  --access-danger: #a92f29;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 0 0 1rem;\n  color: var(--access-ink);\n}\n\n.access-inbox .access-inbox__header {\n  flex-wrap: wrap;\n  margin-bottom: 0;\n}\n\n.access-inbox .access-inbox__header .crumb {\n  min-width: 0;\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .access-inbox__header .crumb-icon,\n.access-inbox .access-inbox__header .pill-btn {\n  flex-shrink: 0;\n}\n\n.access-inbox .access-inbox__description {\n  margin: 0;\n  color: var(--access-muted);\n  font-size: 0.875rem;\n  line-height: 1.6;\n}\n\n.access-inbox .access-button,\n.access-inbox .access-icon-button,\n.access-inbox .btn-approve,\n.access-inbox .btn-deny {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 44px;\n  padding: 0.625rem 1rem;\n  border: 1px solid var(--access-border);\n  border-radius: 0.625rem;\n  background: var(--card, #fff);\n  color: var(--access-ink);\n  font: inherit;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  line-height: 1.4;\n  cursor: pointer;\n  transition: background-color 140ms ease, border-color 140ms ease;\n}\n\n.access-inbox .access-button:hover:not(:disabled),\n.access-inbox .access-icon-button:hover:not(:disabled) {\n  background: #edf2f8;\n  border-color: #aebfd4;\n}\n\n.access-inbox .access-button--quiet {\n  color: var(--access-muted);\n  background: transparent;\n  border-color: transparent;\n}\n\n.access-inbox .access-icon-button {\n  flex: 0 0 44px;\n  width: 44px;\n  padding: 0;\n}\n\n.access-inbox .access-icon-button--danger {\n  color: var(--access-muted);\n  background: transparent;\n  border-color: transparent;\n}\n\n.access-inbox .access-icon-button--danger:hover:not(:disabled) {\n  color: var(--access-danger);\n  background: #fff1f0;\n  border-color: #edc8c5;\n}\n\n.access-inbox button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.access-inbox :is(button, a, input, textarea):focus-visible {\n  outline: 3px solid var(--access-accent);\n  outline-offset: 3px;\n}\n\n.access-inbox .notifications-filters {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem 1.5rem;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--access-border);\n  border-radius: 0.75rem;\n  background: var(--card, #fff);\n}\n\n.access-inbox .notifications-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  min-height: 44px;\n  color: var(--access-ink);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.access-inbox .notifications-toggle input {\n  width: 1rem;\n  height: 1rem;\n  margin: 0;\n  flex: 0 0 1rem;\n  accent-color: var(--access-accent);\n}\n\n.access-inbox .notifications-count {\n  margin-left: auto;\n  color: var(--access-muted);\n  font-size: 0.75rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.access-inbox .notifications-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.access-inbox .dataspace-content-loading--compact {\n  min-height: 18rem;\n  border: 1px solid var(--access-border);\n  border-radius: 0.875rem;\n}\n\n.access-inbox .notification-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  min-width: 0;\n  padding: 1.5rem;\n  border: 1px solid var(--access-border);\n  border-left: 3px solid #94a3b8;\n  border-radius: 0.875rem;\n  background: var(--card, #fff);\n  box-shadow: 0 2px 6px rgba(20, 38, 66, 0.025);\n}\n\n.access-inbox .notification-card[data-status=\"pending\"] {\n  border-left-color: #c48b29;\n}\n\n.access-inbox .notification-card[data-status=\"approved\"] {\n  border-left-color: #258069;\n}\n\n.access-inbox .notification-card:is([data-status=\"denied\"], [data-status=\"revoked\"]) {\n  border-left-color: #c26962;\n}\n\n.access-inbox .notification-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.access-inbox .notification-heading {\n  min-width: 0;\n}\n\n.access-inbox .notification-title {\n  margin: 0;\n  color: var(--access-ink);\n  font-size: 1.0625rem;\n  font-weight: 800;\n  line-height: 1.5;\n  letter-spacing: -0.015em;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .notification-subtitle {\n  margin: 0.25rem 0 0;\n  color: var(--access-muted);\n  font-size: 0.75rem;\n  line-height: 1.6;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .notification-actions-inline {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n.access-inbox .access-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  flex: 0 0 auto;\n  padding: 0.375rem 0.625rem;\n  border: 1px solid var(--access-border);\n  border-radius: 0.5rem;\n  background: var(--access-soft);\n  color: var(--access-muted);\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n.access-inbox .access-status--pending {\n  background: #fff8e8;\n  border-color: #eeddb5;\n  color: var(--access-warning);\n}\n\n.access-inbox .access-status--approved {\n  background: #edf8f3;\n  border-color: #c8e7d9;\n  color: var(--access-positive);\n}\n\n.access-inbox :is(.access-status--denied, .access-status--revoked) {\n  background: #fff1f0;\n  border-color: #efd3d0;\n  color: var(--access-danger);\n}\n\n.access-inbox .notification-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem 1.5rem;\n  margin: 0;\n  padding-top: 1rem;\n  border-top: 1px solid #edf0f4;\n}\n\n.access-inbox .notification-meta > div {\n  min-width: 0;\n}\n\n.access-inbox .notification-meta__wide {\n  grid-column: 1 / -1;\n}\n\n.access-inbox .notification-meta dt {\n  margin: 0 0 0.375rem;\n  color: var(--access-muted);\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.access-inbox .notification-meta dd {\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .notification-meta__wide dd {\n  font-size: 0.8125rem;\n}\n\n.access-inbox .notification-message {\n  padding: 0.875rem 1rem;\n  border-left: 2px solid #bdcde0;\n  border-radius: 0 0.5rem 0.5rem 0;\n  background: var(--access-soft);\n  font-size: 0.875rem;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .notification-message strong {\n  display: block;\n  margin-bottom: 0.375rem;\n  color: var(--access-muted);\n  font-size: 0.75rem;\n}\n\n.access-inbox .notification-message p {\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.access-inbox .notification-decision {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 2rem;\n  padding: 1rem;\n  border: 1px solid var(--access-border);\n  border-radius: 0.625rem;\n  background: var(--access-soft);\n  font-size: 0.8125rem;\n  line-height: 1.6;\n}\n\n.access-inbox .notification-decision > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.375rem;\n  min-width: 0;\n}\n\n.access-inbox .notification-decision strong {\n  color: var(--access-muted);\n}\n\n.access-inbox .notification-decision__comment {\n  flex-basis: 100%;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .notification-consent {\n  display: grid;\n  gap: 1rem;\n  padding: 1.25rem;\n  border: 1px solid #d8e4f2;\n  border-radius: 0.75rem;\n  background: #f5f8fc;\n  font-size: 0.875rem;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .notification-consent__item {\n  display: grid;\n  grid-template-columns: 6rem minmax(0, 1fr);\n  gap: 1rem;\n}\n\n.access-inbox .notification-consent__item strong {\n  font-size: 0.8125rem;\n}\n\n.access-inbox .notification-consent__notice {\n  padding-top: 1rem;\n  border-top: 1px solid #d8e4f2;\n  color: #354864;\n  font-size: 0.8125rem;\n}\n\n.access-inbox .notification-consent__notice p {\n  margin: 0.375rem 0 0;\n}\n\n.access-inbox :is(.notification-consent__invalid, .notifications-error) {\n  padding: 1rem;\n  border: 1px solid #e4bbb7;\n  border-radius: 0.625rem;\n  background: #fff1f0;\n  color: #8b2722;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .notification-actions {\n  display: grid;\n  gap: 1rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--access-border);\n}\n\n.access-inbox .notification-actions h3 {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 800;\n}\n\n.access-inbox .notification-inputs {\n  display: grid;\n  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);\n  align-items: start;\n  gap: 1rem;\n}\n\n.access-inbox .notification-inputs:empty {\n  display: none;\n}\n\n.access-inbox .notification-inputs label {\n  display: grid;\n  min-width: 0;\n  gap: 0.5rem;\n  color: var(--access-muted);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.access-inbox .notification-inputs :is(input, textarea) {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 44px;\n  border: 1px solid #bdcadb;\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  background: var(--card, #fff);\n  color: var(--access-ink);\n  font: inherit;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.access-inbox .notification-inputs textarea {\n  min-height: 5.5rem;\n  resize: vertical;\n}\n\n.access-inbox .notification-inputs textarea::placeholder {\n  color: #65758a;\n  opacity: 1;\n}\n\n.access-inbox .notification-buttons {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.access-inbox .btn-approve {\n  background: var(--access-ink);\n  border-color: var(--access-ink);\n  color: #fff;\n}\n\n.access-inbox .btn-approve:hover:not(:disabled) {\n  background: #25476e;\n  border-color: #25476e;\n}\n\n.access-inbox .btn-deny {\n  color: var(--access-danger);\n  border-color: #e3c9c6;\n}\n\n.access-inbox .btn-deny:hover:not(:disabled) {\n  background: #fff1f0;\n  border-color: #cf9f99;\n}\n\n.access-inbox .notification-actions--compact {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.access-inbox .notification-actions--compact .notification-inputs {\n  display: flex;\n  flex: 1;\n}\n\n.access-inbox .notification-actions--compact .notification-inputs:empty {\n  display: none;\n}\n\n.access-inbox .notification-actions--compact .notification-buttons {\n  margin-left: auto;\n}\n\n.access-inbox .notifications-empty {\n  display: grid;\n  justify-items: center;\n  gap: 0.75rem;\n  padding: 3rem 1.5rem;\n  border: 1px solid var(--access-border);\n  border-radius: 0.875rem;\n  background: var(--card, #fff);\n  text-align: center;\n}\n\n.access-inbox .notifications-empty__icon {\n  display: grid;\n  place-items: center;\n  width: 3.5rem;\n  height: 3.5rem;\n  margin-bottom: 0.25rem;\n  border-radius: 50%;\n  background: #eaf1fa;\n  color: var(--access-accent);\n  font-size: 1.25rem;\n}\n\n.access-inbox .notifications-empty h2 {\n  margin: 0;\n  font-size: 1.0625rem;\n  line-height: 1.5;\n}\n\n.access-inbox .notifications-empty p {\n  margin: 0;\n  color: var(--access-muted);\n  font-size: 0.875rem;\n  line-height: 1.6;\n}\n\n.access-inbox .notifications-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.access-inbox .notifications-page {\n  color: var(--access-muted);\n  font-size: 0.8125rem;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n}\n\n.access-inbox .access-confirm {\n  width: min(32rem, calc(100% - 2rem));\n  max-height: calc(100% - 2rem);\n  margin: auto;\n  padding: 0;\n  overflow-y: auto;\n  border: 1px solid var(--access-border);\n  border-radius: 1rem;\n  background: var(--card, #fff);\n  color: var(--access-ink);\n  box-shadow: 0 24px 80px rgba(20, 38, 66, 0.25);\n}\n\n.access-inbox .access-confirm::backdrop {\n  background: rgba(15, 30, 51, 0.5);\n  backdrop-filter: blur(2px);\n}\n\n.access-inbox .access-confirm__header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1.25rem 1.25rem 0;\n}\n\n.access-inbox .access-confirm__icon {\n  display: grid;\n  place-items: center;\n  flex: 0 0 2.5rem;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 0.625rem;\n  background: #fff1f0;\n  color: var(--access-danger);\n}\n\n.access-inbox .access-confirm__header h2 {\n  margin: 0;\n  font-size: 1.0625rem;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n\n.access-inbox .access-confirm__header .access-icon-button {\n  margin-left: auto;\n  border-color: transparent;\n}\n\n.access-inbox .access-confirm__body {\n  padding: 0.5rem 1.5rem 1rem;\n  color: var(--access-muted);\n  font-size: 0.875rem;\n  line-height: 1.7;\n}\n\n.access-inbox .access-confirm__body p {\n  margin: 0.75rem 0 0;\n}\n\n.access-inbox .access-confirm__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--access-border);\n  background: var(--access-soft);\n}\n\n.access-inbox .access-button--danger {\n  color: #fff;\n  background: var(--access-danger);\n  border-color: var(--access-danger);\n}\n\n.access-inbox .access-button--danger:hover:not(:disabled) {\n  color: #fff;\n  background: #88221e;\n  border-color: #88221e;\n}\n\n@media (max-width: 52rem) {\n  .access-inbox .notifications-count {\n    margin-left: 0;\n  }\n\n  .access-inbox .notification-meta {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 38rem) {\n  .access-inbox {\n    gap: 1rem;\n  }\n\n  .access-inbox .notifications-filters {\n    align-items: stretch;\n    gap: 0.25rem 0.75rem;\n    padding: 0.625rem 0.875rem;\n  }\n\n  .access-inbox .notifications-toggle {\n    width: 100%;\n  }\n\n  .access-inbox .notifications-count {\n    display: flex;\n    align-items: center;\n    min-height: 44px;\n    flex: 1;\n  }\n\n  .access-inbox .notification-card {\n    padding: 1rem;\n    gap: 1rem;\n  }\n\n  .access-inbox .notification-head {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .access-inbox .notification-actions-inline {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .access-inbox .notification-meta {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 0.875rem;\n  }\n\n  .access-inbox .notification-inputs {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .access-inbox .notification-buttons > button {\n    flex: 1;\n  }\n\n  .access-inbox .notification-actions--compact .notification-buttons {\n    width: 100%;\n  }\n\n  .access-inbox .notification-actions--compact .notification-inputs label {\n    width: 100%;\n  }\n\n  .access-inbox .notification-consent {\n    padding: 1rem;\n  }\n\n  .access-inbox .notification-consent__item {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 0.25rem;\n  }\n\n  .access-inbox .notifications-pagination .access-button {\n    padding-inline: 0.625rem;\n  }\n\n  .access-inbox .access-confirm__header {\n    gap: 0.5rem;\n    padding-inline: 1rem;\n  }\n\n  .access-inbox .access-confirm__icon {\n    display: none;\n  }\n\n  .access-inbox .access-confirm__body, .access-inbox .access-confirm__footer {\n    padding-inline: 1rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .access-inbox button {\n    transition: none;\n  }\n}\n\n.notification-delivery { padding: 14px; border: 1px solid #edce9b; border-radius: 10px; background: #fff9ee; margin: 14px 0; }\n.notification-delivery p { margin: 0 0 8px; }\n.notifications-hidden { font-size: 13px; color: #68758b; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
